<template>
<div class="size margin">

  <div class="example">
    <titleComponent value="Calligraphy" mark="01" color="background-yellow" />

    <div class="container-font-example container column">
      <div class="font-example container wrap">
        <div class="flex-basis-100 flex-grow-1">
          <ul class="list-none">
            <li><strong>Font family:</strong> Museo</li>
            <li><strong>Styles:</strong></li>
          </ul>
        </div>
        <div class="flex-basis-100 flex-grow-1">
          <ul class="list-none">
            <li>
              <p>Regular</p>
            </li>
            <li>
              <p><i>Italic</i></p>
            </li>
            <li>
              <p style="font-weight: 800">Semibold</p>
            </li>
            <li>
              <p style="font-weight: bold">Bold</p>
            </li>
          </ul>
        </div>
        <div class="flex-basis-400 flex-grow-3 container wrap justify-content-center align-items-center">
          <div class="flex-basis-200 flex-grow-1">
            <h1>Aa</h1>
            <h5>Museo Bold</h5>
          </div>
          <div class="flex-basis-200 flex-grow-1">
            <h1 style="font-weight: 800">Aa</h1>
            <h5 style="font-weight: 800">Museo Semi Bold</h5>
          </div>
          <div class="flex-basis-200 flex-grow-1">
            <span style="font-size: 3rem">Aa</span>
            <h5 style="font-weight: normal">Museo Regular</h5>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="example">
    <titleComponent value="Typography" mark="01" color="background-blue" />
    <div class="container-font-example container column">
      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <ul class="list-none">
            <li>
              <h4>Heading 1</h4></li>
            <li><strong>Font family:</strong> Museo</li>
            <li><strong>Font size:</strong> 55px</li>
          </ul>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <h1>Almost before we knew it, we had left the ground.</h1>
        </div>
      </div>
      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <ul class="list-none">
            <li>
              <h4>Heading 2</h4></li>
            <li><strong>Font family:</strong> Museo</li>
            <li><strong>Font size:</strong> 43px</li>
          </ul>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <h2>Almost before we knew it, we had left the ground.</h2>
        </div>
      </div>
      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <ul class="list-none">
            <li>
              <h4>Heading 3</h4></li>
            <li><strong>Font family:</strong> Museo</li>
            <li><strong>Font size:</strong> 32px</li>
          </ul>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <h3>Almost before we knew it, we had left the ground.</h3>
        </div>
      </div>
      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <ul class="list-none">
            <li>
              <h4>Heading 4</h4></li>
            <li><strong>Font family:</strong> Museo</li>
            <li><strong>Font size:</strong> 22px</li>
          </ul>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <h4>Almost before we knew it, we had left the ground.</h4>
        </div>
      </div>
      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <ul class="list-none">
            <li>
              <h4>Heading 5</h4></li>
            <li><strong>Font family:</strong> Museo</li>
            <li><strong>Font size:</strong> 18px</li>
          </ul>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <h5>Almost before we knew it, we had left the ground.</h5>
        </div>
      </div>
      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <ul class="list-none">
            <li>
              <h4>Heading 6</h4></li>
            <li><strong>Font family:</strong> Museo</li>
            <li><strong>Font size:</strong> 14px</li>
          </ul>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <h6>Almost before we knew it, we had left the ground.</h6>
        </div>
      </div>
    </div>
  </div>

  <div class="example">
    <titleComponent value="Styles" mark="01" color="background-green" />
    <div class="container-font-example container column">
      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <h4>b.</h4>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <b>Almost before we knew it, we had left the ground.</b>
        </div>
      </div>

      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <h4>p.</h4>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <p>Almost before we knew it, we had left the ground.</p>
        </div>
      </div>

      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <h4>small.</h4>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <small>Almost before we knew it, we had left the ground.</small>
        </div>
      </div>

      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <h4>span.</h4>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <span>Almost before we knew it, we had left the ground.</span>
        </div>
      </div>

      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <h4>i.</h4>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <i>Almost before we knew it, we had left the ground.</i>
        </div>
      </div>

      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <h4>u.</h4>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <u>Almost before we knew it, we had left the ground.</u>
        </div>
      </div>

      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <h4>strike.</h4>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <strike>Almost before we knew it, we had left the ground.</strike>
        </div>
      </div>

      <div class="font-example container">
        <div class="flex-basis-100 flex-grow-1">
          <h4>a.</h4>
        </div>
        <div class="flex-basis-400 flex-grow-2">
          <a href="#">Almost before we knew it, we had left the ground.</a>
        </div>
      </div>

    </div>
  </div>

  <div class="">
    <titleComponent value="Font align" mark="01" color="background-yellow" />
    <div class="container-font-example container column">
      <div class="font-example container wrap">
        <div class="flex-basis-400 flex-grow-3 container wrap justify-content-center align-items-center">
          <div class="box-font flex-basis-200 flex-grow-1 text-left">
            <h1>Aa</h1>
            <h5>Text-left</h5>
          </div>
          <div class="box-font flex-basis-200 flex-grow-1 text-center">
            <h1>Aa</h1>
            <h5>Text-center</h5>
          </div>
          <div class="box-font flex-basis-200 flex-grow-1 text-right">
            <h1>Aa</h1>
            <h5>Text-right</h5>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
</template>

<script>
import titleComponent from '@/components/titleComponent'

export default {
  name: 'topo',
  components: {
    titleComponent
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss" scoped>
.container-font-example {
    padding-top: 20px;
    .font-example {
        padding: 20px;
        box-sizing: border-box;
        margin-bottom: 20px;
    }
}

.box-font {
    border: 1px solid rgba(0,0,0,.1);
    border-radius: 4px;
    padding: 20px;
    box-sizing: border-box;
    margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/styleguide/typography.vue